import { createSlice } from "@reduxjs/toolkit";
import { FULLFILLED } from "@root/constants";
import { GET_UPLOADED_DOCUMENT } from "@root/store/action-types/documents";

interface IInitialValue {
  documentsList: ICurrentChat[];
}
const initialValue: IInitialValue = {
  documentsList: [],
};

export const documentsEntitySlice = createSlice({
  name: "documents",
  initialState: initialValue,
  reducers: {
    updateDocuemntList: (state, action: any) => {
      state.documentsList = action.payload;
    },
   
  },
  extraReducers: (builder) => {
    builder.addCase(`${GET_UPLOADED_DOCUMENT}${FULLFILLED}`, (state, action: any) => {
      state.documentsList = action?.payload?.rows;
    });
  },
});

export const {
  updateDocuemntList,
} = documentsEntitySlice.actions;
export const documentsEntityReducer = documentsEntitySlice.reducer;
